import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';
import { eTypeUser } from '../constants/options-system';
import { TOAST_MESSAGES } from '../constants/app.constants';
import { getCompanyHomeUrl, getCurrentUserTypeId } from './not-found.guard';

/**
 * Restringe una ruta al rol interno Admin iPay (eTypeUser.AdminIpay), sin
 * depender del árbol system_option/user_type_system_option en vivo (que
 * hoy solo modela Business Admin / Admin iPay y no está versionado). Se
 * usa en rutas de configuración sensible (ej. flags de WhatsApp/Nubefact)
 * donde el RPC de guardado también valida el rol server-side.
 */
export const adminIpayOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toastService = inject(ToastService);

  const userTypeId = getCurrentUserTypeId(authService);

  if (userTypeId === eTypeUser.AdminIpay) {
    return true;
  }

  toastService.HanddleWarningMessage(TOAST_MESSAGES.UNAUTHORIZED_ACCESS, 'Acceso denegado');

  return router.parseUrl(getCompanyHomeUrl(userTypeId));
};
